export default "__VITE_ASSET__aZkDSEUm__"